// extracted by mini-css-extract-plugin
export default {"appliedActionContainer":"ScmvfC","actionBody":"hJfZ6l","timestamp":"cNEv9U","actionHeader":"hzuw8n","actionButton":"saaxFJ"};